import type { Reducer } from '@reduxjs/toolkit';
import type { ComponentType } from 'react';
import { injectReducer } from 'app/store';

export default function withReducer(
  key: string,
  reducer: Reducer
): <P extends Record<string, unknown>>(WrappedComponent: ComponentType<P>) => ComponentType<P> {
  return function withReducerHOC<P extends Record<string, unknown>>(
    WrappedComponent: ComponentType<P>
  ): ComponentType<P> {
    injectReducer(key, reducer);

    return function WithReducer(props: P): JSX.Element {
      return <WrappedComponent {...props} />;
    };
  };
}
